import * as Types from '../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Wed Nov 12 2025 21:28:57 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type BulkDownloadRecordStreamsMutationVariables = Types.Exact<{
  input: Types.BulkDownloadRecordStreamsInput;
}>;


export type BulkDownloadRecordStreamsMutation = { __typename?: 'Mutation', bulkDownloadRecordStreams?: { __typename?: 'BulkDownloadRecordStreamsPayload', backgroundJobStatus: { __typename?: 'BackgroundJobStatus', id: string } } | null | undefined };


export const BulkDownloadRecordStreamsDocument = gql`
    mutation BulkDownloadRecordStreams($input: BulkDownloadRecordStreamsInput!) {
  bulkDownloadRecordStreams(input: $input) {
    backgroundJobStatus {
      id
    }
  }
}
    `;
export type BulkDownloadRecordStreamsMutationFn = Apollo.MutationFunction<BulkDownloadRecordStreamsMutation, BulkDownloadRecordStreamsMutationVariables>;

/**
 * __useBulkDownloadRecordStreamsMutation__
 *
 * To run a mutation, you first call `useBulkDownloadRecordStreamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDownloadRecordStreamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDownloadRecordStreamsMutation, { data, loading, error }] = useBulkDownloadRecordStreamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDownloadRecordStreamsMutation(baseOptions?: Apollo.MutationHookOptions<BulkDownloadRecordStreamsMutation, BulkDownloadRecordStreamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDownloadRecordStreamsMutation, BulkDownloadRecordStreamsMutationVariables>(BulkDownloadRecordStreamsDocument, options);
      }
export type BulkDownloadRecordStreamsMutationHookResult = ReturnType<typeof useBulkDownloadRecordStreamsMutation>;
export type BulkDownloadRecordStreamsMutationResult = Apollo.MutationResult<BulkDownloadRecordStreamsMutation>;
export type BulkDownloadRecordStreamsMutationOptions = Apollo.BaseMutationOptions<BulkDownloadRecordStreamsMutation, BulkDownloadRecordStreamsMutationVariables>;